import React from 'react';

const clearIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M15.1673 8.00016C15.1673 11.6818 12.1823 14.6668 8.50065 14.6668C4.81898 14.6668 1.83398 11.6818 1.83398 8.00016C1.83398 4.3185 4.81898 1.3335 8.50065 1.3335C12.1823 1.3335 15.1673 4.3185 15.1673 8.00016Z"
      fill="#0BC196"
    />
    <path
      d="M12.0286 4.86182L7.50531 9.39048L5.63798 7.52848L4.69531 8.47115L7.50665 11.2758L12.9716 5.80448L12.0286 4.86182Z"
      fill="#089171"
    />
  </svg>
);

const notClearIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M14.6673 8.00016C14.6673 11.6818 11.6823 14.6668 8.00065 14.6668C4.31898 14.6668 1.33398 11.6818 1.33398 8.00016C1.33398 4.3185 4.31898 1.3335 8.00065 1.3335C11.6823 1.3335 14.6673 4.3185 14.6673 8.00016Z"
      fill="#DF3030"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8279 6.11454L9.88521 5.17188L7.99988 7.05721L6.11454 5.17188L5.17188 6.11454L7.05721 7.99987L5.17188 9.88521L6.11454 10.8279L7.99988 8.94254L9.88521 10.8279L10.8279 9.88521L8.94254 7.99987L10.8279 6.11454Z"
      fill="#B11B1B"
    />
  </svg>
);

const arrowRight = (
  <svg
    width="13"
    height="22"
    viewBox="0 0 13 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.353516 21.2287L11.5392 11.3327C11.6343 11.2483 11.6887 11.1273 11.6887 11.0001C11.6887 10.8729 11.6343 10.7518 11.5392 10.6674L0.353516 0.771484"
      stroke="#394A64"
    />
  </svg>
);

const colouredWarning = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M13.3331 13.5124H2.66646C2.42746 13.5124 2.20746 13.3847 2.08846 13.1777C1.9698 12.9707 1.97046 12.716 2.0908 12.5097L7.42413 3.17637C7.54346 2.9717 7.7628 2.8457 7.9998 2.8457C8.2368 2.8457 8.45613 2.9717 8.5758 3.17637L13.9091 12.5097C14.0295 12.716 14.0301 12.9707 13.9115 13.1777C13.7928 13.3847 13.5718 13.5124 13.3331 13.5124Z"
      fill="#C1840B"
    />
    <path
      d="M7.33398 11.5594C7.33398 11.4697 7.34965 11.3877 7.38165 11.3107C7.41298 11.2347 7.45798 11.1687 7.51598 11.1134C7.57298 11.0574 7.64332 11.0137 7.72398 10.9824C7.80532 10.9517 7.89665 10.9354 7.99865 10.9354C8.10065 10.9354 8.19265 10.9517 8.27465 10.9824C8.35798 11.0137 8.42832 11.0574 8.48532 11.1134C8.54365 11.1687 8.58865 11.2347 8.61965 11.3107C8.65165 11.3877 8.66732 11.4697 8.66732 11.5594C8.66732 11.6494 8.65165 11.7314 8.61965 11.806C8.58832 11.881 8.54332 11.9457 8.48532 12.002C8.42832 12.0574 8.35798 12.1007 8.27465 12.1327C8.19265 12.1634 8.10065 12.1787 7.99865 12.1787C7.89632 12.1787 7.80532 12.1634 7.72398 12.1324C7.64332 12.1004 7.57298 12.057 7.51598 12.0017C7.45765 11.9454 7.41265 11.8807 7.38165 11.8057C7.34965 11.731 7.33398 11.649 7.33398 11.5594ZM8.49398 10.1787H7.50298L7.36265 6.17871H8.63398L8.49398 10.1787Z"
      fill="#614205"
    />
  </svg>
);

const bookmarkIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5032 5.16349H16.3358C16.1515 5.16349 16.0022 5.01416 16.0022 4.82995V4.66318C16.0022 4.29476 15.7035 3.99609 15.3351 3.99609H13.3339C12.9655 3.99609 12.6668 4.29476 12.6668 4.66318V11.0005C12.6666 11.1356 12.7478 11.2575 12.8726 11.3092C12.9974 11.3609 13.1411 11.3323 13.2365 11.2366L14.2164 10.256C14.2477 10.2246 14.2902 10.207 14.3345 10.207C14.3788 10.207 14.4213 10.2246 14.4526 10.256L15.4325 11.2366C15.5279 11.3323 15.6716 11.3609 15.7964 11.3092C15.9212 11.2575 16.0025 11.1356 16.0022 11.0005V6.8312C16.0022 6.64699 16.1515 6.49766 16.3358 6.49766H17.1696C17.3538 6.49766 17.5032 6.64699 17.5032 6.8312V18.3384C17.5032 18.5226 17.3538 18.6719 17.1696 18.6719H8.83107C8.64686 18.6719 8.49753 18.5226 8.49753 18.3384V6.8312C8.49753 6.64699 8.64686 6.49766 8.83107 6.49766H11.4994C11.5915 6.49766 11.6662 6.42299 11.6662 6.33089V5.33026C11.6662 5.23816 11.5915 5.16349 11.4994 5.16349H6.49628C5.75944 5.16349 5.16211 5.76082 5.16211 6.49766V18.6719C5.16211 19.4088 5.75944 20.0061 6.49628 20.0061H17.5032C18.24 20.0061 18.8373 19.4088 18.8373 18.6719V6.49766C18.8373 5.76082 18.24 5.16349 17.5032 5.16349Z"
      fill="#394A64"
    />
    <mask id="mask0_3447_92366" x="5" y="3" width="14" height="18">
      <path
        d="M17.5032 5.16349H16.3358C16.1515 5.16349 16.0022 5.01416 16.0022 4.82995V4.66318C16.0022 4.29476 15.7035 3.99609 15.3351 3.99609H13.3339C12.9655 3.99609 12.6668 4.29476 12.6668 4.66318V11.0005C12.6666 11.1356 12.7478 11.2575 12.8726 11.3092C12.9974 11.3609 13.1411 11.3323 13.2365 11.2366L14.2164 10.256C14.2477 10.2246 14.2902 10.207 14.3345 10.207C14.3788 10.207 14.4213 10.2246 14.4526 10.256L15.4325 11.2366C15.5279 11.3323 15.6716 11.3609 15.7964 11.3092C15.9212 11.2575 16.0025 11.1356 16.0022 11.0005V6.8312C16.0022 6.64699 16.1515 6.49766 16.3358 6.49766H17.1696C17.3538 6.49766 17.5032 6.64699 17.5032 6.8312V18.3384C17.5032 18.5226 17.3538 18.6719 17.1696 18.6719H8.83107C8.64686 18.6719 8.49753 18.5226 8.49753 18.3384V6.8312C8.49753 6.64699 8.64686 6.49766 8.83107 6.49766H11.4994C11.5915 6.49766 11.6662 6.42299 11.6662 6.33089V5.33026C11.6662 5.23816 11.5915 5.16349 11.4994 5.16349H6.49628C5.75944 5.16349 5.16211 5.76082 5.16211 6.49766V18.6719C5.16211 19.4088 5.75944 20.0061 6.49628 20.0061H17.5032C18.24 20.0061 18.8373 19.4088 18.8373 18.6719V6.49766C18.8373 5.76082 18.24 5.16349 17.5032 5.16349Z"
        fill="white"
      />
    </mask>
  </svg>
);

export { clearIcon, notClearIcon, arrowRight, colouredWarning, bookmarkIcon };
